import styled from 'styled-components';

export const StyledIframe = styled.iframe`
  width: 0;
  height: 0;
  border: none;
`;
